export const THIRD_PARTY_ACCESS_BASE_URL = '/api/thirdpartyaccess'

export const PROFESSIONALS_API_HEADERS = { 'api-version': '1' } as const

// Counts-only endpoint: returns `groupCounts` and `remainingInvitationCount`
// for the current parent user. Does not return invitation/match records -
// call GET_CONNECTIONS_ENDPOINT for those once `groupCounts.total > 0`.
export const GET_OVERVIEW_ENDPOINT = `${THIRD_PARTY_ACCESS_BASE_URL}/getoverview`

// Combined, parent-visible list of invitations and relationships.
export const GET_CONNECTIONS_ENDPOINT = `${THIRD_PARTY_ACCESS_BASE_URL}/getconnections`

// Single invitation or relationship connection detail, keyed by `id` + `type`.
// Replaces the now-obsolete GetInvitationDetail/GetDetails endpoints.
export const GET_CONNECTION_DETAIL_ENDPOINT = `${THIRD_PARTY_ACCESS_BASE_URL}/getconnectiondetail`

export const CREATE_PROFESSIONAL_ENDPOINT = `${THIRD_PARTY_ACCESS_BASE_URL}/invite`

export const CANCEL_PROFESSIONAL_ENDPOINT = `${THIRD_PARTY_ACCESS_BASE_URL}/cancelinvitation`

export const APPROVE_INVITATION_ENDPOINT = `${THIRD_PARTY_ACCESS_BASE_URL}/approve`
export const DENY_INVITATION_ENDPOINT = `${THIRD_PARTY_ACCESS_BASE_URL}/deny`

// Ends an active match/relationship (not yet wired to any UI - follow-up story).
export const REVOKE_MATCH_ENDPOINT = `${THIRD_PARTY_ACCESS_BASE_URL}/revoke`

export const INVITATION_EXPIRY_WINDOW_DAYS = 5

// Used for `route.meta.trackingName` so `TPMobileHeader.vue` renders
// `ProfessionalsMobileHeader.vue` for professionals routes. Not a Bloomreach
// tracking value - this feature isn't tracked there.
export const PROFESSIONALS_TRACKING_NAME = 'professionals'
